import { render, staticRenderFns } from "./commission.vue?vue&type=template&id=355f0313&scoped=true"
import script from "./commission.vue?vue&type=script&lang=js"
export * from "./commission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355f0313",
  null
  
)

export default component.exports